import { render, staticRenderFns } from "./scatter.vue?vue&type=template&id=688b37fb&scoped=true&"
import script from "./scatter.vue?vue&type=script&lang=js&"
export * from "./scatter.vue?vue&type=script&lang=js&"
import style0 from "./scatter.vue?vue&type=style&index=0&id=688b37fb&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688b37fb",
  null
  
)

export default component.exports